import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { connect } from 'react-redux';
import properties from '../../../../modules/ajio-util/properties';
import * as actions from '../../../../actions/productData';
import { isCatalogNameInFirebaseStore } from '../../../../utils/common';
import { getStoresForHidingMRP } from '../../../../refresh/selectors/featureFlagsSelector';
import { replaceWithJioCDN } from '../../../../../src/utils/imageHandling';

class ShopTheCapsule extends React.Component {
  constructor(props) {
    super(props);
  }

  openModal(prodData, e) {
    if (e) e.preventDefault();
    this.props.openModal(prodData);
  }

  render() {
    const { product = {}, storesForHidingMRP } = this.props;
    const data = Object.keys(product).length === 0 ? '' : product;
    if (Object.keys(data).length === 0) {
      return null;
    }
    let capsulesData = data.products;

    return (
      <div className="comp-section">
        <h4 className="align-center">
          <span>Shop The Capsule</span>
        </h4>
        <Row className="capsule-section">
          <Col className="capsule-left">
            {capsulesData && capsulesData[0] && (
              <DataList
                storesForHidingMRP={storesForHidingMRP}
                data={capsulesData[0]}
                openModal={this.openModal.bind(this)}
              />
            )}
          </Col>
          <Col md={6}>
            <a href={`/capsuleLanding/${data.id}`} className="prod-sec">
              <div className="sec-prod-disp">
                <img
                  className="sec-img"
                  src={`${replaceWithJioCDN(data.imageURL)}`}
                  width="524px"
                  height="326px"
                  alt={`${data.title}`}
                />
              </div>
            </a>
          </Col>
          <Col className="capsule-right">
            {capsulesData && capsulesData[1] && (
              <DataList
                storesForHidingMRP={storesForHidingMRP}
                data={capsulesData[1]}
                openModal={this.openModal.bind(this)}
              />
            )}
          </Col>
        </Row>
      </div>
    );
  }
}
class DataList extends React.Component {
  render() {
    const { storesForHidingMRP } = this.props;
    const data = this.props.data;
    let { url } = data;
    let image = data.fnlColorVariantData.outfitPictureURL;
    let { colorGroup } = data.fnlColorVariantData;
    let { catalogName } = data;
    const hideMRP = isCatalogNameInFirebaseStore(storesForHidingMRP, catalogName);
    return (
      <a href={`${url}`} className="prod-sec">
        <div className="sec-prod-disp">
          <img className="sec-img" src={`${replaceWithJioCDN(image)}`} width="204px" height="256px" />

          {data.fnlColorVariantData.exclusiveTill ? (
            <div className="sec-prod-exclusive" aria-label="EXCLUSIVE">EXCLUSIVE</div>
          ) : (
            ''
          )}
          {data.fnlColorVariantData.allPromotions ? <div className="sec-prod-offer" /> : ''}

          <div
            id="quickview"
            className="prod-quickview"
            onClick={this.props.openModal.bind(this, colorGroup)}
          >
            <span>QUICK VIEW</span>
          </div>
        </div>

        <div className="sec-product-details">
          <div className="sec-prod-title" aria-label={data.fnlColorVariantData.brandName}>{data.fnlColorVariantData.brandName}</div>
          <div className="sec-prod-subtitle" aria-label={data.name}>{data.name}</div>
          {data.price && data.price.displayformattedValue ? (
            <div className="sec-prod-cp">{data.price.displayformattedValue}</div>
          ) : (
            ''
          )}

          {data.wasPriceData &&
          data.wasPriceData.value &&
          data.wasPriceData.value > data.price.value &&
          hideMRP ? (
            <div className="sec-prod-price">
              <span className="sec-prod-sp">
                <span>{data.wasPriceData.displayformattedValue}</span>
              </span>
              &nbsp;
              <span className="discount-percent">&nbsp;({data.discountPercent})</span>
            </div>
          ) : (
            ''
          )}
        </div>
      </a>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    product: state.product.capsules,
    storesForHidingMRP: getStoresForHidingMRP(state)
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  let productId = ownProps.productCode;
  return {
    fetchData: setTimeout(function() {
      dispatch(actions.getCapsulesData(productId));
    }, 500),
    openModal: productId => dispatch(actions.openModal(productId))
  };
};

export default ShopTheCapsule = connect(mapStateToProps, mapDispatchToProps)(ShopTheCapsule);
